import { render, staticRenderFns } from "./dytSelect.vue?vue&type=template&id=52c83f28&"
import script from "./dytSelect.vue?vue&type=script&lang=js&"
export * from "./dytSelect.vue?vue&type=script&lang=js&"
import style0 from "./dytSelect.vue?vue&type=style&index=0&id=52c83f28&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports